module.exports = __webpack_public_path__ + "static/media/Cafe.9894f880.svg";